export default "__VITE_ASSET__CPCogI7T__"